// src/features/sso-auth/components/CallbackPage.tsx
import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { AuthService } from '../services/authService';

const CallbackPage: React.FC = () => {
  const [isProcessing, setIsProcessing] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const setTokens = useAuthStore(state => state.setTokens);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { query, data, error: urlError } = AuthService.getUrlParams();

        // Check if there's an error in the URL
        if (urlError) {
          setError(`Error de autenticación: ${urlError}`);
          setIsProcessing(false);
          return;
        }

        // Check if we have the required parameters
        if (!query || !data) {
          setError('Parámetros de autenticación faltantes');
          setIsProcessing(false);
          return;
        }

        // Exchange code for tokens
        const tokenResponse = await AuthService.checkToken(query, data);

        await setTokens(tokenResponse.access_token, tokenResponse.refresh_token);
        localStorage.setItem("access_token", tokenResponse.access_token);
        localStorage.setItem("refresh_token", tokenResponse.refresh_token);
        // hacer que isAuthenticated sea true
        useAuthStore.setState({ isAuthenticated: true });
        // Obtener el usuario desde el endpoint y guardarlo en localStorage
        const user = await useAuthStore.getState().getUserFromToken(tokenResponse.access_token);
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
        }
        window.location.href = '/';

      } catch (err) {
        console.error('Callback error:', err);
        setError('Error al procesar la autenticación');
        setIsProcessing(false);
      }
    };

    void handleCallback();
  }, [setTokens]);

  const handleRetry = () => {
    window.location.href = '/login';
  };

  if (isProcessing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Procesando autenticación...
          </h2>
          <p className="text-gray-600">
            Por favor espera mientras completamos tu inicio de sesión.
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.084 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Error de Autenticación
            </h2>
            <p className="text-gray-600 mb-6">
              {error}
            </p>
            <button
              onClick={handleRetry}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Intentar de nuevo
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default CallbackPage;